module.exports = __webpack_public_path__ + "img/RIC.46aade37.svg";